import { useState } from "react";

import { useAddFieldPracticeParticipations, useDeleteFieldPracticeParticipations, useTranslation } from "utils";

import { PRACTICE_SLUG } from "models";

import { Message as message } from "components";

export const useEnrollField = ({
  fieldId,
  farmId,
  isMineralFertilizerActive = false,
}: {
  fieldId?: string;
  farmId?: string;
  isMineralFertilizerActive?: boolean;
}) => {
  const { t } = useTranslation("allFieldView");
  const [enrollmentLoading, setEnrollmentLoading] = useState(false);

  const { mutateAsync: addFieldPracticeParticipationsAsync } = useAddFieldPracticeParticipations(fieldId ? [fieldId] : [], farmId);
  const { mutateAsync: deleteFieldPracticeParticipationsAsync } = useDeleteFieldPracticeParticipations(fieldId ? [fieldId] : [], farmId);

  const handleEnrollField = async (value: boolean) => {
    if (!fieldId) return;

    const practiceToEnroll = [PRACTICE_SLUG.CROPS, PRACTICE_SLUG.SEEDINGS, PRACTICE_SLUG.TILLAGES, PRACTICE_SLUG.ORGANIC_FERTILIZERS];
    setEnrollmentLoading(true);
    try {
      if (value) {
        const response = await addFieldPracticeParticipationsAsync([{ fieldId, practiceSlugs: practiceToEnroll }]);
        if (response.success) {
          message({ content: t("allFieldView:fieldEnrollmentDrawer.successEnrollingField"), icon: "tick" });
          if (response.skippedPractices.length > 0) {
            message({ content: JSON.stringify(response.skippedPractices), icon: "error" });
          }
        } else {
          message({ content: t("allFieldView:fieldEnrollmentDrawer.errorEnrollingField"), icon: "error" });
        }
      } else {
        const practiceToUnenroll = [...practiceToEnroll, ...(isMineralFertilizerActive ? [PRACTICE_SLUG.MINERAL_FERTILIZERS] : [])];
        const response = await deleteFieldPracticeParticipationsAsync({ fieldId, practiceSlugs: practiceToUnenroll });
        // @ts-expect-error fine
        if (response.success) {
          message({ content: t("allFieldView:fieldEnrollmentDrawer.successUnenrollingField"), icon: "tick" });
        } else {
          message({ content: t("allFieldView:fieldEnrollmentDrawer.errorUnenrollingField"), icon: "error" });
        }
      }
    } finally {
      setEnrollmentLoading(false);
    }
  };

  return { handleEnrollField, enrollmentLoading };
};
